import { deviceType } from "@tm/isomorphic-utils";
import styled from "styled-components";

export const TravellerDetailLayoutV2 = styled.div`
  width: 100%;
  padding: 50px 0;
  background-image: linear-gradient(180deg, #282a47 0.38%, #554276 100%);
  background-size: 100% 157px;
  background-color: #f4f4f4;
  background-repeat: no-repeat;
  padding-top: 16px;
  position: relative;
  z-index: 2;
  .userSection {
    img,
    picture {
      flex-shrink: 1;
    }
  }
  height: 100%;
`;

export const HeadComp = styled.div`
  width: 1192px;
  margin: 0 auto 10px auto;
`;

export const MainContainer = styled.div`
  margin: 0 auto;
  width: 1200px;
  display: flex;
  justify-content: space-between;
  gap: 12px;
`;
export const LeftComp = styled.div`
  width: 1027px;
  gap: 12px;
  display: flex;
  flex-direction: column;
`;

export const RightComp = styled.div`
  width: 440px;
  gap: 12px;
  display: flex;
  flex-direction: column;
`;

export const WebToastWrap = styled.div`
  div {
    height: 40px;
  }
  @media ${deviceType.mobile} {
    position: fixed;
    bottom: 108px;
    width: 100%;
    & > {
      width: 100%;
    }
    div {
    }
  }
  @media ${deviceType.desktop} {
    & > div {
      margin-left: 30px;
    }
    div {
      width: 502px;
    }
    position: sticky;
    bottom: 120px;
  }
`;
